var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_error",
    transform: "translate(-151.045 -144)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 31.5,
    cy: 31.5,
    r: 31.5,
    transform: "translate(151.045 144)",
    fill: "#ffe3eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23936",
    "data-name": "Path 23936",
    d: "M328.841,140a2.174,2.174,0,0,0-2.173,2.173v15.209a2.173,2.173,0,1,0,4.345,0V142.173A2.174,2.174,0,0,0,328.841,140Z",
    transform: "translate(-145.796 21.865)",
    fill: "#f70154"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23937",
    "data-name": "Path 23937",
    d: "M331.011,375.507a2.173,2.173,0,1,1-2.173-2.173,2.173,2.173,0,0,1,2.173,2.173",
    transform: "translate(-145.794 -189.742)",
    fill: "#f70154"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoError);
export default __webpack_public_path__ + "static/media/ico_error.32781d56f5f38bb8af3dbc75fa3bcd0e.svg";
export { ForwardRef as ReactComponent };